{
  "files.answer.empty": "No files match.",
  "files.answer.failed": "Could not load the files.",
  "files.answer.kind.all": "All",
  "files.answer.kind.document": "Document",
  "files.answer.kind.folder": "Folder",
  "files.answer.kind.image": "Image",
  "files.answer.kind.media": "Media",
  "files.answer.kind.note": "Note",
  "files.answer.kind.other": "File",
  "files.answer.title": "Files",
  "files.answer.untitled": "Untitled",
  "files.contextMenu.cleanUpGrid": "Clean up grid",
  "files.contextMenu.copyLink": "Copy link",
  "files.contextMenu.delete": "Delete",
  "files.contextMenu.deleteMany": "Delete {count} items",
  "files.contextMenu.download": "Download",
  "files.contextMenu.getInfo": "Get info",
  "files.contextMenu.moveToFolder": "Move to folder…",
  "files.contextMenu.moveToNotes": "Move to Notes",
  "files.contextMenu.moveToPrivate": "Move to private",
  "files.contextMenu.moveToPrivateDenied": "Move to private — creator only",
  "files.contextMenu.moveToShared": "Move to shared",
  "files.contextMenu.newFolder": "New folder",
  "files.contextMenu.newTab": "Open in new tab",
  "files.contextMenu.open": "Open",
  "files.contextMenu.openIn": "Open in {app}",
  "files.contextMenu.openInInstall": "Open in {app}…",
  "files.contextMenu.openWith": "Open with",
  "files.contextMenu.rename": "Rename",
  "files.contextMenu.selectAll": "Select all",
  "files.contextMenu.sharePublic": "Share public link…",
  "files.contextMenu.uploadFiles": "Upload files",
  "files.delete.confirmTitle": "Delete “{name}”?",
  "files.delete.confirmTitleMany": "Delete {count} items?",
  "files.delete.failedMessage": "“{name}” was not deleted. It is still here.",
  "files.delete.failedTitle": "Delete failed",
  "files.delete.itemFallback": "item",
  "files.delete.messageMany": "This permanently removes these items and any stored file. This can’t be undone.",
  "files.delete.messageManyFolder": "This permanently removes these items — folders delete everything inside them — and any stored file. This can’t be undone.",
  "files.delete.messageOne": "This permanently removes this item and any stored file. This can’t be undone.",
  "files.delete.messageOneFolder": "This permanently removes this item — folders delete everything inside them — and any stored file. This can’t be undone.",
  "files.desktop.dragHandle": "Drag to chat or canvas",
  "files.desktop.dropHint": "Drop files to upload",
  "files.download.failedTitle": "Download failed",
  "files.folderPicker.desktop": "Desktop",
  "files.folderPicker.empty": "No folders yet",
  "files.folderPicker.folder": "Folder",
  "files.handler.notes": "Notes",
  "files.info.created": "Created",
  "files.info.createdBy": "Created by",
  "files.info.dimensions": "Dimensions",
  "files.info.duration": "Duration",
  "files.info.format": "Format",
  "files.info.itemCount": "{count} items",
  "files.info.itemOne": "1 item",
  "files.info.items": "Items",
  "files.info.kind": "Kind",
  "files.info.measuring": "Measuring…",
  "files.info.modified": "Modified",
  "files.info.sharing": "Sharing",
  "files.info.sharingPrivate": "Private (only you)",
  "files.info.sharingShared": "Shared (workspace)",
  "files.info.size": "Size",
  "files.info.storagePath": "Storage path",
  "files.info.where": "Where",
  "files.infoType.doc": "Document",
  "files.infoType.folder": "Folder",
  "files.infoType.html": "Html",
  "files.infoType.image": "Image",
  "files.infoType.md": "Md",
  "files.infoType.other": "Other",
  "files.infoType.pdf": "Pdf",
  "files.infoType.text": "Text",
  "files.infoType.video": "Video",
  "files.link.copiedMessage": "{name} — universal link copied to clipboard",
  "files.link.copiedTitle": "Link copied",
  "files.link.copyFailedTitle": "Copy failed",
  "files.link.fallbackName": "Link",
  "files.node.untitled": "Untitled",
  "files.openWith.icloudMessage": "iCloud can’t open a file from a link, so a copy of “{name}” was downloaded — drop it into the {app} tab that just opened.",
  "files.openWith.icloudTitle": "Opening {app}",
  "files.openWith.thisFile": "this file",
  "files.page.files.title": "Files",
  "files.rename.failedMessage": "Couldn't rename — the previous name was restored.",
  "files.rename.failedTitle": "Rename failed",
  "files.scope.moveFailedMessage": "Nothing was moved — the previous location was restored.",
  "files.scope.moveFailedPrivateTitle": "Couldn’t move everything to private",
  "files.scope.moveFailedSharedTitle": "Couldn’t move everything to shared",
  "files.scope.movePartialFromPrivate": "{failed} of {total} items stayed in Private — they are still visible there.",
  "files.scope.movePartialFromShared": "{failed} of {total} items stayed in Shared — they are still visible there.",
  "files.scope.privateDeniedMany": "{count} of the selected items were created by somebody else. A private item is visible to its creator only, so moving them would hide them from everybody.",
  "files.scope.privateDeniedOne": "“{name}” was created by {who}. A private item is visible to its creator only, so this move would hide it from everybody — including {who}.",
  "files.scope.privateDeniedThisItem": "This item",
  "files.scope.privateDeniedTitle": "Only the creator can make this private",
  "files.sidebar.actionsGroup": "ACTIONS",
  "files.sidebar.canvasGroup": "CANVAS",
  "files.sidebar.filterAll": "All",
  "files.sidebar.filterDocs": "Documents",
  "files.sidebar.filterFolders": "Folders",
  "files.sidebar.filterGroup": "FILTER",
  "files.sidebar.filterImages": "Images",
  "files.sidebar.filterVideos": "Videos",
  "files.sidebar.locationGroup": "LOCATION",
  "files.sidebar.navLabel": "Files navigation",
  "files.sidebar.newFolder": "New folder",
  "files.sidebar.scopePrivate": "Private",
  "files.sidebar.scopeShared": "Shared",
  "files.sidebar.upload": "Upload",
  "files.upload.failedTitle": "Upload failed",
  "files.viewer.download": "Download",
  "files.viewer.moreActions": "More actions",
  "files.viewer.openInDrive": "Open in Google Drive",
  "files.empty.title": "A place for your team’s work",
  "files.empty.hint": "Drop files anywhere on the canvas, or add a folder to get organized.",
  "files.empty.filtered": "No files match this view",
  "files.empty.error": "Files could not be loaded",
  "files.empty.errorHint": "Check your connection and reopen Files to try again."
}
